import { Component } from '@angular/core';
import { MsalBroadcastService } from '@azure/msal-angular';
import { map } from 'rxjs/operators';

@Component({
  selector: 'em-login-failed',
  templateUrl: './login-failed.component.html',
  standalone: false,
})
export class LoginFailedComponent {
  // TODO `error` is empty when we reach this :(
  // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4578
  public error$ = this.msalBroadcastService.msalSubject$.pipe(map((x) => x.error?.message));

  public constructor(private readonly msalBroadcastService: MsalBroadcastService) {}
}
